import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findByList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/campusIntroduction/findByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 介绍
  findIntroductionByOrgId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padIntroduction/findByOrgId`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveIntroduction({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padIntroduction/save`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 校区分布
  getPadDistributePageList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padDistribute/page`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  upload({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/file/upload`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  uploadDistribute({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`padDistribute/importExcel`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  downLoadDistribute({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "padDistribute/exportExcel",
        data: params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  
  // 师资
  getPadFacultyPageList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padFaculty/page`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getFacultyById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/padFaculty/findById`, {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveFaculty({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padFaculty/saveOrUpdate`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  delFacultyById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`padFaculty/delById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 成功案例
  getPadCasePageList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padCase/page`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getCaseById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/padCase/findById`, {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveCase({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/padCase/saveOrUpdate`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  delCaseById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`padCase/delById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadImg({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/policyInterpretation/uploadImg`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}









